import request from '@/utils/request'

export function addDemand(data) {
  return request({
    url: '/app-api/website/demand/create',
    method: 'post',
    data: data
  })
}

export function getDynamic(data) {
  return request({
    url: '/app-api/website/dynamic/page',
    method: 'get',
    params: data
  })
}
